<template>
  <v-chart :options="options" :auto-resize="true"></v-chart>
</template>

<script>
export default {
  props: {
    value: {
      default: () => {}
    }
  },
  computed: {
    options() {
      return {
        series: [
          {
            type: "pie",
            radius: "55%",
            data: this.chartData,
            label: {
              formatter: "{b} \n {c} \n {d}%",
              fontSize: 20
              // position: 'outside',
              // verticalAlign: 'bottom',
              // alignTo: 'edge',
              // margin: '-5%'
            },
            animationEasing: "elasticOut",
            animationDelay: () => {
              return Math.random() * 200;
            }
          }
        ]
      };
    },
    chartData() {
      return [
        {
          name: "Not active",
          value: this.value.total,
          itemStyle: {
            color: "#D50000"
          }
        },
        {
          name: "Logged in",
          value: this.value.logins,
          itemStyle: {
            color: "#FF6F00"
          }
        },
        {
          name: "Active",
          value: this.value.performing,
          itemStyle: {
            color: "#388E3C"
          }
        }
      ];
    }
  }
};
</script>
